/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const X24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="X (twitter) 24">
      <path
        fill="#1C1C1C"
        fillRule="evenodd"
        d="M9.242 12.64 1 2h6.528l5.087 6.576L18.05 2.03h3.596l-7.292 8.793L23 22h-6.508l-5.51-7.112-5.88 7.092H1.487l7.755-9.34Zm8.198 7.389L5.003 3.97h1.576L19 20.03h-1.56Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: X24,
  md: X24,
  lg: X24,
  xl: X24,
  xxl: X24,
  xxxl: X24,
};

export const XIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'x-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
